import { render } from "./ChooseOrganisation.vue?vue&type=template&id=4ecedf87"
import script from "./ChooseOrganisation.vue?vue&type=script&lang=js"
export * from "./ChooseOrganisation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__